"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Availability = void 0;
const availability_schema_1 = require("./availability.schema");
const base_model_1 = require("../base-model");
class Availability extends base_model_1.BaseModel {
    constructor(data, skipValidation) {
        super(data, skipValidation);
    }
    getDefaults() {
        return {
            isUta: false,
        };
    }
    getSchema() {
        return availability_schema_1.availabilitySchema;
    }
}
exports.Availability = Availability;
